module.exports = __webpack_public_path__ + "static/media/insightsLogo.18294150.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insightsLogo.svg
// module id = 2437
// module chunks = 0